<template>
  <ResultTableComponent class="ml-5 mr-5 mb-5" :keyword="keyword" :filterByItemCodes="true" />
</template>

<script>
import ResultTableComponent from '../components/ResultTableComponent.vue';
import TitleComponent from '../components/TitleComponent.vue';
import { resultTableMixin } from '../mixins/resultTableMixin';

export default {
  components: { ResultTableComponent, TitleComponent },
  mixins: [
    resultTableMixin,
  ],
  data() {
    return {
      keyword: 'variant5',
    };
  },
};
</script>